import React, { useRef, useEffect, useLayoutEffect, useState } from 'react';
import ReactPlayer from 'react-player';
import { useSelector } from 'react-redux';
import { getNavbarHeight, getViewportDimensions } from '../../../../models/Utils';
import { credoStoryTypes } from '../../../../models/Models';

import { ADALandmarks, ADAARIARoles } from '../../../../models/ADA';

import LearnMoreLink from '../../../Common/LearnMoreLink/LearnMoreLink';

import './Story.scss';

const Story = React.forwardRef(({ story, index, general, onDisplayStory, onFocusButton }, theRef) => {
  const menuOpened = useSelector(state => state.data.menuOpened);
  const mediaPath = useSelector(state => state.config.basePath + state.config.apiMediaPath);

  const handleButtonFocus = (event) => {
    const element = event.target;
    setTimeout(() => {
      let offsetTop = 0;
      let currentElement = element;
      do {
        offsetTop += currentElement.offsetTop || 0;
        currentElement = currentElement.parentNode;
      } while (currentElement)
      const viewport = getViewportDimensions();
      if (offsetTop - document.body.scrollTop + element.offsetHeight > viewport.height) {
        try {
          element.scrollIntoView({ block: 'center' });
        } catch (e) {
          element.scrollIntoView(false);
        }
        onFocusButton();
      }
    }, 10);
  };

  const imagePart = (
    <div
      className="credo-ss-story-image-holder"
      role="img"
      aria-label={story.Template == credoStoryTypes.VideoText || story.Template == credoStoryTypes.VideoTextCompany ? story.Video.AltText : story.Photo.AltText}
      style={{
        backgroundImage: `url("${mediaPath}${story.Template == credoStoryTypes.VideoText || story.Template == credoStoryTypes.VideoTextCompany ? story.Video.BackgroundMedia : story.Photo.Image}")`
      }}
    />
  );
  const textPart = (
    <div className="credo-ss-story-text-holder">
      <div className="credo-ss-story-preview-title" role={ADAARIARoles.Heading}>{story.PreviewTitle}</div>
      <div className="credo-ss-story-learn-more-holder">
        <button
          className="credo-button"
          tabIndex={!menuOpened ? 0 : -1}
          onClick={onDisplayStory}
          onFocus={handleButtonFocus}
          aria-label={story.LearnMoreAltText ? story.LearnMoreAltText : null}
        >{general.StoryLearnMore}</button>
      </div>
    </div>
  );

  return (
    <div
      className="credo-ss-story"
      tabIndex="-1"
      role={ADAARIARoles.Article}
      aria-label={`Story ${index+1}: ${story.PreviewTitle}`}
      ref={theRef}
    >
      {
        index % 2
        ?
        <>{textPart}{imagePart}</>
        :
        <>{imagePart}{textPart}</>
      }
      <div className="credo-ss-story-divider"></div>
    </div>
  );
});

export default Story;